<template>
    <div class="states-filter">
        <div class="state-group" v-for="(group, index) in options" :key="index">
            <div class="state-label" :id="group.label">{{group.label}}</div>
            <div class="state-option" v-for="(option, index) in group.options"
             :key="index" v-on:click="filter(option.value)">
                {{option.label}}
            </div>
        </div>
        <div class="state-panel">
            <a v-for="(item, index) in markers" :key="index" :href="item">
                {{item[1]}}
            </a>
        </div>
    </div>
</template>

<script>
import {stateOptions} from "@/utils/states";
export default {
  name: "state-filter",
  props: {
    filter: Function
  },
  data() {
    return {
      options: [],
      markers: ['#A', '#B', '#C', '#D', '#E', '#F', '#G', '#H', '#I', '#J', '#K', '#L', '#M', '#N',
        '#O', '#P', '#Q', '#R', '#S', '#T', '#U', '#V', '#W', '#X', '#Y', '#Z'
      ]
    }
  },
  mounted() {
    this.options = stateOptions;
  }
}
</script>

<style lang="scss" scoped>
@font-face {
    font-family: SFProText-Semibold;
    src: url(../../../assets/fonts/SF-Pro-Text-Bold.otf);
}

@font-face {
    font-family: SFProText-Regular;
    src: url(../../../assets/fonts/SF-Pro-Text-Regular.otf);
}

@font-face {
    font-family: SFProText-Medium;
    src: url(../../../assets/fonts/SF-Pro-Text-Medium.otf);
}

.states-filter {
    width: 100%;
    background-color: #fff;
    position: relative;
    .state-group {
        .state-label {
            background-color: rgb(246, 247, 250);
            padding: 10px 20px;
            color: #72768e;
            font-size: 14px;
            font-family: SFProText-Semibold;
        }

        .state-option {
            margin: 0 15px;
            color: #72768e;
            background-color: #ffffff;
            border-bottom: 1px solid #e7ebf3;
            padding: 10px 0px;
            font-size: 16px;
            font-family: SFProText-Regular
        }
    }
    .state-panel {
        position: fixed;
        top: 120px;
        right: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        a {
            font-family: SFProText-Medium;
            font-size: 12px;
            display: inline-block;
            margin-right: 4px;
            text-align: center;
            text-decoration: none;
            color: rgb(67, 72, 104);
        }

        a:hover {
          color: #168cd8;
        }
    }
}
</style>